import { Box, Divider, Typography } from "@material-ui/core"
import React from 'react'
import { useSelector } from "react-redux"
import logo from "../../../../../src/assets/img//nepal-government.png"
import { AppMisc } from "../../../../misc/appMisc"
import { USER_INFO } from "../../../../utils/constants"
import { DateUtils } from "../../../../utils/dateUtils"
import { SessionStorage } from "../../../../utils/storage/sessionStorage"
import styles from "./style"

const ExperienceCertificate = ({ data, experienceCertificateRef, ...props }) => {
  const classes = styles();
  const settingData = useSelector(state => state.settingData);
  const userInfo = SessionStorage.getItem(USER_INFO);
  return (
    <Box ref={experienceCertificateRef} margin={5}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box>
          <img className={classes.officeLogo} src={logo} alt="government logo" />
        </Box>
        <Box display={"flex"} flexDirection={"column"} gridRowGap={5}>
          <Typography align="center" variant="h5">{AppMisc.getMunicipalityEnglishLabel(userInfo?.palikaName)}</Typography>
          <Typography align="center" variant="h5">Office of Municipal Executive</Typography>
          <Typography align="center" variant="h6">{`${AppMisc.getEnglishDistrictLabel(userInfo?.district)},${AppMisc.getProvinceEnglishLabelFromDistrictValue(userInfo?.district)},Nepal`}</Typography>
        </Box>
        {settingData?.logoUrl?.absolutePath &&
          <Box>
            <img className={classes.officeLogo} src={settingData?.logoUrl?.absolutePath} alt="organization logo" />
          </Box>
        }
      </Box>
      <Divider className={classes.divider} />
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box display={"flex"} flexDirection={"column"} gridRowGap={2}>
          <Typography>Fiscal Year: {DateUtils.getFiscalYearFromDateMilli(Date.now())}</Typography>
          <Typography >Ref No: </Typography>
        </Box>
        <Typography>Date: {DateUtils.getDateFromMilliseconds(Date.now())}</Typography>
      </Box>
      <Typography align="center" className={classes.underLine} variant="h6">Subject: Letter of Experience </Typography>
      <Box>
        <Typography align="center" variant="h6">To whom it may concern</Typography>
      </Box>

      <Box mt={5}>
        <Typography align="left" variant="h6">{`This is to certify that  ${data?.personalInfo?.gender === "MALE" ? 'Mr.' : 'Mrs.'} ${data?.personalInfo?.fullNameInEnglish},had worked as a ${data?.currentServiceInfo?.post}
      in this municipality from ${DateUtils.getDateFromMilliseconds(data?.currentServiceInfo?.appointmentToCurrentPostDate)} to ${DateUtils.getDateFromMilliseconds(data?.retirementDetail?.date)}.`}</Typography>

        <Typography align="left" variant="h6">{`Throughout this period, I found in ${data?.personalInfo?.gender === "MALE" ? 'him' : 'her'} highly professional communication skills and clarity on ${data?.personalInfo?.gender === "MALE" ? 'his' : 'her'} roles, duties, and
      responsibilities. ${data?.personalInfo?.gender === "MALE" ? 'His' : 'Her'} sincerity & regularity in work habits and work performances are quite impressive and notable. I wish ${data?.personalInfo?.gender === "MALE" ? 'him' : 'her'}
      every success in ${data?.personalInfo?.gender === "MALE" ? 'his' : 'her'} further academic and professional career. Please feel free to contact us if you require any further information `}</Typography>

      </Box>

      <Box display={"flex"} justifyContent={"end"}>
        <Box display={"flex"} flexDirection={"column"}>
          <Typography align="center">..........................</Typography>
          <Typography align="center"> (CAO)</Typography>
        </Box>
      </Box>
      <Divider className={classes.divider} />

      <Typography align="center">Mailing Address:</Typography>
      <Typography align="center">{`${AppMisc.getEnglishDistrictLabel(userInfo?.district)},${AppMisc.getProvinceEnglishLabelFromDistrictValue(userInfo?.district)},Nepal`}</Typography>

    </Box>
  )
}

export default ExperienceCertificate
